resourcePaths = '{"rootPath":"","assetsPath":""}';function InputText() {
  this.extends = [_Input];
  this.node = null;
  this.id = null;
  this._initialized = true;
  this._pending = null;

  // Determine if the user is on a restricted input device
  this.maskOnBlur = $("html.touch").length > 0;

  // Properties
  this.placeholder = "";
  this.error = "";
  this.maxLength = undefined;
  this.showFloatingLabel = false;
  this.floatingLabelText = "";
  this.mask = {
    format: undefined,
    placeholder: "",
    add: undefined,
    remove: undefined,
  };

  // Classes
  this._classes = {
    container: "input-text",
    input: "input-text__input",
    clear: "input-text__clear",
    clear_icon: "input-text__clear-icon",
    placeholder: "input-text__placeholder",
    mod_empty: "input-text--empty",
    mod_hover: "input-text--hover",
    mod_focus: "input-text--focus",
    mod_readonly: "input-text--readonly",
    mod_disabled: "input-text--disabled",
    mod_inputmask: "input-text--inputmask",
  };

  // Events
  this._events = {
    update:
      "keyup.InputText_update change.InputText_update update.InputText_update input.InputText_update",
    empty:
      "keyup.InputText_update change.InputText_update update.InputText_update input.InputText_update",
    mouseOver: "mouseover.InputText",
    mouseOut: "mouseout.InputText",
    focus: "focus.InputText",
    blur: "blur.InputText",
    clear: "click.InputText_clear",
  };

  // only use update and change events for value processing
  if (this.maskOnBlur) this._events.update = "blur.InputText_update";

  // Elements
  this.containerDiv = $("<div></div>").addClass(this._classes.container);
  this.$placeholder = $("<label></label>").addClass(this._classes.placeholder);
  this.$clearInput = $("<div></div>").addClass(this._classes.clear);
  this._$clearInputSvg = $(
    '<svg class="svg-icon ' +
      this._classes.clear_icon +
      '" viewBox="0 0 32 32" focusable="false"><use xlink:href="#icon-crosscir" /></svg>'
  );
  this.$clearInput.append(this._$clearInputSvg);

  this.init = function () {
    // Setup the input
    this.$node = $(this.node);
    this.$node.attr("type", "text");
    this.$node.addClass(this._classes.input);

    // Setup placeholder
    this.$placeholder.html(this.placeholder);
    this.$placeholder.attr("for", this.id);

    // Setup the input container
    this.containerDiv.insertBefore(this.$node);
    this.containerDiv.append(this.$node);
    this.containerDiv.append(this.$placeholder);
    this.containerDiv.append(this.$clearInput);

    // Add Events
    this.$node.on(this._events.update, this._updateInput.bind(this));
    this.$node.on(this._events.empty, this._setEmptyState.bind(this));
    this.containerDiv.on(this._events.mouseOver, this._onMouseOver.bind(this));
    this.containerDiv.on(this._events.mouseOut, this._onMouseOut.bind(this));
    this.$node.on(this._events.focus, this._onFocus.bind(this));
    this.$node.on(this._events.blur, this._onBlur.bind(this));
    this.$clearInput.on(this._events.clear, this._clearInput.bind(this));

    // Update component state
    this._updateInput();
    this._setEmptyState();
    this._setupInputMask();
    this._setupFloatingLabel(); // https://mogofintech.atlassian.net/browse/ACCT-1143
    this._setupInputMaxLength();
    this.setReadonlyState(this.hasNativeReadonly());
    this.setDisabledState(this.hasNativeDisabled());

    // Display the component
    this.containerDiv.addClass("show");
    this._super();
  };

  this.initAllReady = function () {};

  this.destroy = function () {};

  this._pendingCallback = function (value) {
    this.val(value);
  };

  // return the input value or set the value
  this.val = function (value) {
    if (!this._initialized) {
      if (arguments.length > 0 && value !== "")
        this._pending = ["_pendingCallback", value];
      return;
    }

    if (arguments.length > 0) {
      this.$node.val(this._addMask(value));
    } else {
      return this._removeMask(this.$node.val());
    }

    // update input state
    this._updateInput();
    this._setEmptyState();
  };

  this.setReadonlyState = function (boolean) {
    if (boolean) {
      // set component to readonly
      this.$node.attr("readonly", "readonly");
      this.$node.attr("tabindex", "-1");
      this.containerDiv.addClass(this._classes.mod_readonly);
    } else {
      // set component to editable
      this.$node.removeAttr("readonly");
      this.$node.removeAttr("tabindex");
      this.containerDiv.removeClass(this._classes.mod_readonly);
    }
  };

  this.hasNativeReadonly = function () {
    // check if the input is nativly set to readonly
    return this.$node[0].hasAttribute("readonly");
  };

  this.setDisabledState = function (boolean) {
    if (boolean) {
      // set component to readonly
      this.$node.attr("disabled", "disabled");
      this.$node.attr("tabindex", "-1");
      this.containerDiv.addClass(this._classes.mod_disabled);
    } else {
      // set component to editable
      this.$node.removeAttr("disabled");
      this.$node.removeAttr("tabindex");
      this.containerDiv.removeClass(this._classes.mod_disabled);
    }
  };

  this.hasNativeDisabled = function () {
    // check if the input is nativly set to disabled
    return this.$node[0].hasAttribute("disabled");
  };

  this._updateInput = function () {
    // force max length
    if (
      typeof this.maxLength !== "undefined" &&
      String(this.val()).length > this.maxLength
    ) {
      // remove extra characters from string
      this.val(String(this.val()).substring(0, this.maxLength));
    }
  };

  this._setEmptyState = function () {
    // Set if Input is empty or not
    if (this.$node.val().length > 0) {
      this.containerDiv.removeClass(this._classes.mod_empty);
    } else {
      this.containerDiv.addClass(this._classes.mod_empty);
    }
  };

  this._setupInputMaxLength = function () {
    // Add/Remove native max length depending if there is a mask or component max length applied
    // use native maxlength if the user is on a restricted input device
    if (
      ((this.mask.format === undefined &&
        typeof this.mask.add !== "function") ||
        this.maskOnBlur) &&
      this.maxLength > 0
    ) {
      this.$node.attr("maxlength", this.maxLength);
    }
  };

  this._setupInputMask = function () {
    // configure and apply a input mask to non-restricted input devices
    // see plugin docs here: https://github.com/RobinHerbots/Inputmask
    if (!this.maskOnBlur && this.mask.format !== undefined) {
      this.containerDiv.addClass(this._classes.mod_inputmask);
      this.$node.inputmask("mask", {
        mask: this.mask.format,
        placeholder: this.mask.placeholder,
        showMaskOnHover: false,
        autoUnmask: true,
      });
    }

    // https://mogofintech.atlassian.net/browse/ACCT-1143
    this._setupFloatingLabel = function () {
      // Input element needs [data-mogo-ui-show-floating-label] and [data-mogo-ui-floating-label-text] attr's
      if (this.showFloatingLabel && this.floatingLabelText !== "") {
        this.containerDiv
          .addClass("floating-label-container")
          .find("input[data-mogo-ui-show-floating-label]")
          .after(
            '<label class="floating-label">' +
              this.floatingLabelText +
              "</label>"
          );
        this.containerDiv.find(".input-text__placeholder").remove();
      }
    };

    if (!this.maskOnBlur && this.mask.alias === "mogoCurrency") {
      this.containerDiv.addClass(this._classes.mod_inputmask);
      this.$node.inputmask("mask", {
        alias: "currency",
        placeholder: this.mask.placeholder,
        showMaskOnHover: false,
        autoUnmask: true,
        prefix: "",
        rightAlign: false,
        radixPoint: this.mask.radixPoint ? this.mask.radixPoint : ".",
        digits: this.mask.digits ? this.mask.digits : 2,
        allowMinus: this.mask.allowMinus ? this.mask.allowMinus : false,
      });
    }
  };

  this._addMask = function (value) {
    // apply the data mask if avalible
    if (
      (this.mask.format === undefined || this.maskOnBlur) &&
      typeof this.mask.add === "function"
    ) {
      return this.mask.add(value);
    }

    return value;
  };

  this._removeMask = function (value) {
    // remove the data mask if avalible
    if (
      (this.mask.format === undefined || this.maskOnBlur) &&
      typeof this.mask.remove === "function"
    ) {
      return this.mask.remove(value);
    }

    return value;
  };

  this._clearInput = function () {
    // reset the input
    this.val("");
    this.$node.trigger("change");
    this.$node.focus();
  };

  // add event modifier classes
  this._onMouseOver = function () {
    clearTimeout(this._mouseOutTimeout);
    this.containerDiv.addClass(this._classes.mod_hover);
  };

  this._onMouseOut = function () {
    this._mouseOutTimeout = setTimeout(
      function () {
        this.containerDiv.removeClass(this._classes.mod_hover);
      }.bind(this),
      75
    );
  };

  this._onFocus = function () {
    this.containerDiv.addClass(this._classes.mod_focus);

    // remove a mask on focus if the user has a fallback mask function and is on a restricted input device
    if (
      this.maskOnBlur &&
      this.mask.format !== undefined &&
      typeof this.mask.remove === "function"
    ) {
      this.$node.val(this.mask.remove(this.val()));
    }
  };

  this._onBlur = function () {
    this.containerDiv.removeClass(this._classes.mod_focus);

    // apply a mask on blur if the user has a fallback mask function and is on a restricted input device
    if (
      this.maskOnBlur &&
      this.mask.format !== undefined &&
      typeof this.mask.add === "function"
    ) {
      this.$node.val(this.mask.add(this.val()));
      this.$node.trigger("change");
    }
  };
}
